/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type DeleteOrganizationRemoteSessionClientRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type DeleteOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationRemoteSessionClientSecurity$Outbound,
    DeleteOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function deleteOrganizationRemoteSessionClientSecurityToJSON(
  deleteOrganizationRemoteSessionClientSecurity:
    DeleteOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    DeleteOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      deleteOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type DeleteOrganizationRemoteSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationRemoteSessionClientRequest$Outbound,
    DeleteOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function deleteOrganizationRemoteSessionClientRequestToJSON(
  deleteOrganizationRemoteSessionClientRequest:
    DeleteOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    DeleteOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      deleteOrganizationRemoteSessionClientRequest,
    ),
  );
}
